import { defineRegistry } from '@json-render/react';

import { catalog } from './catalog';
import {
  CardComponent,
  DataTable,
  GenUIAccordion,
  GenUIAlert,
  GenUIAreaChart,
  GenUIBadge,
  GenUIBarChart,
  GenUICollapsible,
  GenUIComboChart,
  GenUIHeading,
  GenUIHeatmap,
  GenUIProgress,
  GenUISankeyChart,
  GenUIScatterChart,
  GenUISelect,
  GenUISlider,
  GenUITabs,
  GenUIText,
  GenUIToggleGroup,
  GridComponent,
  LineChart,
  StackComponent,
} from './components';
import { FundamentalsSeasonalityChart } from './FundamentalsSeasonalityChart';
import { SatelliteImage } from './SatelliteImage';
import { ShippingMap } from './ShippingMap';
import { DaysToExpiryChart, ForwardCurveChart, PercentileChart, SeasonalityChart } from './SymbolCharts';
import { TradingViewChart } from './TradingViewChart';

/**
 * json-render component registry for Oilytics dashboards.
 *
 * Uses defineRegistry to get typed component functions ({ props, children,
 * bindings }) instead of raw { element } access. The registry wraps each
 * ComponentFn so the Renderer can continue passing ComponentRenderProps.
 */
const { registry } = defineRegistry(catalog, {
  components: {
    Grid: GridComponent,
    Stack: StackComponent,
    Card: CardComponent,
    LineChart,
    BarChart: GenUIBarChart,
    AreaChart: GenUIAreaChart,
    ScatterChart: GenUIScatterChart,
    DataTable,
    TradingViewChart,
    SeasonalityChart,
    ForwardCurveChart,
    PercentileChart,
    DaysToExpiryChart,
    FundamentalsSeasonalityChart,
    ShippingMap,
    SatelliteImage,
    SankeyChart: GenUISankeyChart,
    Heatmap: GenUIHeatmap,
    ComboChart: GenUIComboChart,
    ToggleGroup: GenUIToggleGroup,
    Slider: GenUISlider,
    Select: GenUISelect,
    Tabs: GenUITabs,
    Accordion: GenUIAccordion,
    Collapsible: GenUICollapsible,
    Text: GenUIText,
    Heading: GenUIHeading,
    Badge: GenUIBadge,
    Alert: GenUIAlert,
    Progress: GenUIProgress,
  },
});

export { registry };
